import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 親なしサブコレクションの一括削除 ")
const _hoisted_2 = { class: "space-y-4 text-sm" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_4 = { class: "text-lg font-bold" }
const _hoisted_5 = { class: "mt-2 text-2xl" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-xs text-gray-500" }, " このまま、閉じずにお待ちください。 ", -1)
const _hoisted_7 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_8 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_9 = { class: "bg-gray-50 rounded-md p-3 text-center" }
const _hoisted_10 = { class: "text-2xl font-bold" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "削除できる", -1)
const _hoisted_12 = { class: "bg-gray-50 rounded-md p-3 text-center" }
const _hoisted_13 = { class: "text-2xl font-bold" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "削除される文書の合計", -1)
const _hoisted_15 = { class: "bg-gray-50 rounded-md p-3 text-center" }
const _hoisted_16 = { class: "text-2xl font-bold" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "削除できない", -1)
const _hoisted_18 = { class: "text-gray-600" }
const _hoisted_19 = { class: "bg-red-50 border border-red-300 rounded-md p-3 text-red-700" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "font-bold" }, "この操作は取り消せません。", -1)
const _hoisted_21 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "font-bold mb-1" }, "削除できない（実行しません）", -1)
const _hoisted_24 = { class: "border border-gray-200 rounded-md divide-y divide-gray-200" }
const _hoisted_25 = { class: "font-mono break-all text-xs" }
const _hoisted_26 = { class: "text-xs text-gray-600" }
const _hoisted_27 = {
  key: 2,
  class: "space-y-4"
}
const _hoisted_28 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_29 = { class: "bg-green-50 rounded-md p-3 text-center" }
const _hoisted_30 = { class: "text-2xl font-bold text-green-700" }
const _hoisted_31 = { class: "text-xs text-gray-500" }
const _hoisted_32 = { class: "bg-yellow-50 rounded-md p-3 text-center" }
const _hoisted_33 = { class: "text-2xl font-bold text-yellow-700" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "断られた", -1)
const _hoisted_35 = { class: "bg-red-50 rounded-md p-3 text-center" }
const _hoisted_36 = { class: "text-2xl font-bold text-red-700" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "エラー", -1)
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "font-bold mb-1" }, "断られた", -1)
const _hoisted_40 = { class: "border border-gray-200 rounded-md divide-y divide-gray-200" }
const _hoisted_41 = { class: "font-mono break-all text-xs" }
const _hoisted_42 = { class: "text-xs text-gray-600" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "font-bold mb-1" }, "エラー", -1)
const _hoisted_45 = { class: "border border-gray-200 rounded-md divide-y divide-gray-200" }
const _hoisted_46 = { class: "font-mono break-all text-xs" }
const _hoisted_47 = { class: "text-xs text-red-700" }
const _hoisted_48 = { class: "flex items-center" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 閉じる ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 閉じる ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MButton = _resolveComponent("MButton")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, {
    size: "content",
    "show-close-button": !_ctx.busy,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        (_ctx.busy)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.stage === "checking" ? "内容を確認中..." : "削除中..."), 1),
              _createVNode("div", _hoisted_5, _toDisplayString(_ctx.progress.done) + " / " + _toDisplayString(_ctx.progress.total), 1),
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (_ctx.stage === 'confirm')
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.deletable.length) + "件", 1),
                  _hoisted_11
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, _toDisplayString(_ctx.totalDocs) + "件", 1),
                  _hoisted_14
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, _toDisplayString(_ctx.excluded.length) + "件", 1),
                  _hoisted_17
                ])
              ]),
              _createVNode("p", _hoisted_18, " 内訳: 移動済みの残骸 " + _toDisplayString(_ctx.movedCount) + " 件 / 所有者不明 " + _toDisplayString(_ctx.ownerlessCount) + " 件 ", 1),
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                (_ctx.ownerlessCount > 0)
                  ? (_openBlock(), _createBlock("p", _hoisted_21, " 所有者が見つからないデータを含みます。内容を確認してから実行してください。 "))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.excluded.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode("ul", _hoisted_24, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.excluded, (item) => {
                        return (_openBlock(), _createBlock("li", {
                          key: item.path,
                          class: "p-2"
                        }, [
                          _createVNode("div", _hoisted_25, _toDisplayString(item.path), 1),
                          _createVNode("div", _hoisted_26, _toDisplayString(item.reason), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.stage === 'done')
          ? (_openBlock(), _createBlock("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, _toDisplayString(_ctx.outcome.deleted.length) + "件 ", 1),
                  _createVNode("div", _hoisted_31, " 削除（文書 " + _toDisplayString(_ctx.deletedDocs) + " 件） ", 1)
                ]),
                _createVNode("div", _hoisted_32, [
                  _createVNode("div", _hoisted_33, _toDisplayString(_ctx.outcome.refused.length) + "件 ", 1),
                  _hoisted_34
                ]),
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, _toDisplayString(_ctx.outcome.errors.length) + "件 ", 1),
                  _hoisted_37
                ])
              ]),
              (_ctx.outcome.refused.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode("ul", _hoisted_40, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.outcome.refused, (item) => {
                        return (_openBlock(), _createBlock("li", {
                          key: item.path,
                          class: "p-2"
                        }, [
                          _createVNode("div", _hoisted_41, _toDisplayString(item.path), 1),
                          _createVNode("div", _hoisted_42, _toDisplayString(item.reason), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.outcome.errors.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode("ul", _hoisted_45, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.outcome.errors, (item) => {
                        return (_openBlock(), _createBlock("li", {
                          key: item.path,
                          class: "p-2"
                        }, [
                          _createVNode("div", _hoisted_46, _toDisplayString(item.path), 1),
                          _createVNode("div", _hoisted_47, _toDisplayString(item.message), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_48, [
        (_ctx.stage === 'confirm')
          ? (_openBlock(), _createBlock(_component_MButton, {
              key: 0,
              text: "",
              color: "gray-600",
              class: "mr-4",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withCtx(() => [
                _hoisted_49
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.stage === 'confirm')
          ? (_openBlock(), _createBlock(_component_MButton, {
              key: 1,
              color: "red-600",
              disabled: _ctx.deletable.length === 0,
              onClick: _ctx.confirmAndExecute
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.deletable.length) + " 件を削除 ", 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.stage === 'done')
          ? (_openBlock(), _createBlock(_component_MButton, {
              key: 2,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
            }, {
              default: _withCtx(() => [
                _hoisted_50
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show-close-button"]))
}